module.exports = __webpack_public_path__ + "static/hands-6962fc091ffb279442f1137fd6eb0a21.gif";